import { CSSObject } from '@chakra-ui/react';
import bg from '@/assets/goldenbet888/images/backgrounds/bg.png';
import { CustomButtonProps } from '@/components/Button/Button';

export const FlexPageWrapper = (): CSSObject => ({
  flexDirection: 'column',
  h: undefined,
  justifyContent: 'center',
  minH: '100vh',
  bg: `url(${bg}) center/cover no-repeat`,
  color: 'gamma.200',
  fontFamily: 'body',
});

export const MaintenanceContainer = (): CSSObject => ({
  alignItems: 'center',
  contain: 'paint',
  gap: '0',
  h: undefined,
  justifyContent: 'center',
  maxW: 'container.md',
  mb: [null, null, '12'],
  minH: [null, null, '668px'],
  mt: ['0', null, '12'],
  mx: 'auto',
  pos: 'relative',
  px: ['4', null, '28'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
  w: 'full',
  zIndex: '1',

  _before: {
    content: '""',
    h: '275px',
    left: '0',
    pos: 'absolute',
    top: '0',
    w: 'full',
    zIndex: '-1',
  },
});

export const ContentHeadingText: CSSObject = {
  color: 'gamma.600',
  textShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  w: ['278px', '468px'],
  fontSize: ['xl', null, '32px'],
  fontFamily: 'accentMusashi',
  lineHeight: 'none',
  mb: '4',
  mt: '4',
  textTransform: 'uppercase',
  '&[data-ismaintenance="true"]': {
    w: ['278px', '500px'],
  },
};

export const ContentBodyText: CSSObject = {
  span: {
    display: 'block',
    fontSize: ['sm', null, 'md'],
    fontWeight: 'semibold',
    mb: '4',
  },
  fontWeight: 'normal',
  fontSize: ['xs', null, 'sm'],
  mb: '4',
};

export const buttonRefreshProps: CustomButtonProps = {
  color: 'blackAlpha.700',
  variant: 'solid',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  h: '10',
  minW: '102px',
  lineHeight: 'normal',
};

export const TextBoldDescription: CSSObject = {
  fontSize: 'md',
  color: 'gamma.200',
};
